import { uploadEntityAttachments, fetchEntityAttachmentFiles, deleteAttachment } from '@/lib/entity-attachments';
import type { GenericAttachment } from '@/styles/GenericAttachmentsSection';

/** Thin bid-flavoured facade over the shared attachments implementation (entity type 'bid'). */
export const bidAttachmentService = {
  /** Uploads one file to a bid (Storage object + attachment row). Throws with the real reason when it fails. */
  async uploadBidAttachment(file: File, bidId: string, session: { companyId: string; userId: string }): Promise<GenericAttachment> {
    let reason = '';
    const [uploaded] = await uploadEntityAttachments('bid', bidId, [file], session.companyId, session.userId, {
      onFileError: (_name, why) => { reason = why; },
    });
    if (!uploaded) throw new Error(`"${file.name}" could not be uploaded${reason ? `: ${reason}` : ''}`);
    return uploaded;
  },

  /** The Storage object path of the bid's PDF (its newest one), or null when it has none. */
  async getBidPdfStoragePath(bidId: string): Promise<string | null> {
    const files = await fetchEntityAttachmentFiles('bid', bidId);
    return files.find((file) => file.file_type === 'application/pdf' || file.file_name.toLowerCase().endsWith('.pdf'))?.storage_path ?? null;
  },

  async deleteBidAttachment(attachmentId: string, userId: string | undefined): Promise<void> {
    if (!(await deleteAttachment(attachmentId, userId))) throw new Error('Failed to delete the attachment');
  },
};
